"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const PlaceholderLoading = (props) => {
    return ((0, jsx_runtime_1.jsx)("span", { className: `placeholder placeholder-loading ${props.containerClassName || ''}`, style: { height: props.height || 20, ...props.containerStyle } }));
};
exports.default = PlaceholderLoading;
